/**
 * 나눔터 글을 라이브러리 가족 아이템 모양으로 읽는다.
 * source_data.versions 가 있으면 그대로, 없으면 download_url + outline 1버전.
 */

import { familyVersions, parseOutline } from './libraryFamily';

export const galleryItemAsFamily = (item) => {
  if (!item || typeof item !== 'object') return null;
  const source = item.source_data && typeof item.source_data === 'object' ? item.source_data : {};
  const mapped = {
    ...item,
    versions: source.versions || item.versions,
    outline: parseOutline(source.versions?.text?.outline)
      || parseOutline(source.outline)
      || parseOutline(item.outline)
      || null,
    preview_urls: source.versions?.image?.page_urls || source.previews || item.preview_urls || [],
    download_url: item.download_url || source.downloadUrl || source.download_url || null,
    filename: source.versions?.text?.filename
      || source.versions?.image?.filename
      || source.filename
      || item.filename,
  };
  const versions = familyVersions(mapped);
  let latest = item.latest_version;
  if (latest !== 'text' && latest !== 'image') {
    if (versions.image && mapped.download_url && versions.image.file_url === mapped.download_url) {
      latest = 'image';
    } else if (versions.text && mapped.download_url && versions.text.file_url === mapped.download_url) {
      latest = 'text';
    }
  }
  return {
    ...mapped,
    versions,
    latest_version: latest || item.latest_version,
    outline: versions.text?.outline || mapped.outline,
    preview_urls: versions.image?.page_urls?.length ? versions.image.page_urls : mapped.preview_urls,
  };
};
